module.exports = __webpack_public_path__ + "img/icon-1-84a7f8b0.svg";